<div class="flex min-h-screen flex-col items-center justify-center gap-10 bg-gray-100 py-10" *transloco="let t; read: 'auth.resetPassword'">
  <img src="assets/images/logo/taxtimer-logo.svg" alt="TaxTimer Logo" />
  <div class="flex flex-col items-center justify-center gap-1.5">
    <h2 class="text-primary">{{ t('title') }}</h2>
    <p class="text-large-bold">{{ email }}</p>
  </div>
  <div class="relative z-10 min-h-[422px] w-[640px] rounded-[5px] bg-white p-8">
    <form
      [formGroup]="passwordResetForm"
      (ngSubmit)="onSubmit()"
      [ngClass]="{ 'blur-md': isLoading }"
      class="flex h-full flex-col justify-between gap-4"
    >
      <div>
        <div class="mb-6">
          <app-form-element
            [label]="t('form.password')"
            [labelFor]="'password'"
            [showRequiredAsterisk]="false"
            [validationMessages]="{ passwordMismatch: t('validation.passwordMismatch') }"
          >
            <input appTogglePassword class="form-control" id="password" type="password" formControlName="password" />
          </app-form-element>
        </div>

        <div>
          <app-form-element
            [label]="t('form.confirmPassword')"
            [labelFor]="'confirmPassword'"
            [showRequiredAsterisk]="false"
            [validationMessages]="{ passwordMismatch: t('validation.passwordMismatch') }"
          >
            <input
              appTogglePassword
              class="form-control"
              id="confirmPassword"
              type="password"
              formControlName="confirmPassword"
              (focus)="onConfirmPasswordFocus()"
            />
          </app-form-element>
        </div>
      </div>
      @if (password) {
        <app-password-strength [password]="password" [showText]="true" [showIndicator]="true"></app-password-strength>
      }

      <p class="text-medium-regular text-gray-600">{{ (passwordPolicy | passwordRequirementsText) || t('passwordRequirements') }}</p>
      <div>
        <button type="submit" [disabled]="isLoading || !isPasswordValid" class="btn btn-primary w-full justify-center">
          {{ t('button.resetPassword') }}
        </button>
      </div>
    </form>
    @if (isLoading) {
      <div class="absolute top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
        <app-loader color="blue"></app-loader>
      </div>
    }
  </div>
  <app-legal-links-container></app-legal-links-container>
</div>
